var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "grupo-consolidado"
  }, [_c('div', {
    staticClass: "card card-custom mb-6"
  }, [_c('div', {
    staticClass: "card-header border-0 pt-6"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-light-primary",
    attrs: {
      "to": {
        name: 'grupoEmpresa'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left mr-1"
  }), _vm._v(" Voltar ao grupo ")])], 1)]), _c('div', {
    staticClass: "card-body pt-4"
  }, [_vm.carregandoInicial ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('span', {
    staticClass: "spinner spinner-primary"
  })]) : _vm.grupo ? [_c('div', {
    staticClass: "painel-filtros mb-6"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.carregarDashboard.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-items-end"
  }, [_c('b-form-group', {
    staticClass: "filtro-data mr-3 mb-0",
    attrs: {
      "label": "De",
      "label-for": "consolidado-inicio"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "consolidado-inicio",
      "type": "date",
      "required": ""
    },
    model: {
      value: _vm.filtros.inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "inicio", $$v);
      },
      expression: "filtros.inicio"
    }
  })], 1), _c('b-form-group', {
    staticClass: "filtro-data mr-3 mb-0",
    attrs: {
      "label": "Até",
      "label-for": "consolidado-fim"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "consolidado-fim",
      "type": "date",
      "min": _vm.filtros.inicio,
      "required": ""
    },
    model: {
      value: _vm.filtros.fim,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "fim", $$v);
      },
      expression: "filtros.fim"
    }
  })], 1), _c('b-form-group', {
    staticClass: "filtro-empresas mr-3 mb-0",
    attrs: {
      "label": "Empresas"
    }
  }, [_c('b-dropdown', {
    attrs: {
      "variant": "light",
      "menu-class": "seletor-empresas-menu",
      "no-flip": "",
      "block": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-flex align-items-center justify-content-between w-100"
        }, [_c('span', {
          staticClass: "text-truncate"
        }, [_vm._v(" " + _vm._s(_vm.resumoEmpresasSelecionadas) + " ")]), _c('i', {
          staticClass: "fas fa-chevron-down ml-3 font-size-xs"
        })])];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-form', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('strong', [_vm._v("Empresas incluídas")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" " + _vm._s(_vm.filtros.empresas.length) + "/" + _vm._s(_vm.opcoesEmpresas.length) + " ")])]), _c('div', {
    staticClass: "seletor-empresas-lista"
  }, _vm._l(_vm.opcoesEmpresas, function (empresa) {
    return _c('b-form-checkbox', {
      key: empresa.value,
      staticClass: "seletor-empresa-item",
      attrs: {
        "value": empresa.value
      },
      model: {
        value: _vm.filtros.empresas,
        callback: function callback($$v) {
          _vm.$set(_vm.filtros, "empresas", $$v);
        },
        expression: "filtros.empresas"
      }
    }, [_c('span', {
      staticClass: "d-flex align-items-center justify-content-between"
    }, [_c('span', [_vm._v(_vm._s(empresa.nome))]), _c('small', {
      staticClass: "text-muted ml-4"
    }, [_vm._v(" " + _vm._s(empresa.tipo) + " ")])])]);
  }), 1), _c('div', {
    staticClass: "d-flex border-top pt-3 mt-3"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-light-primary mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selecionarTodas
    }
  }, [_vm._v(" Todas ")]), _c('button', {
    staticClass: "btn btn-xs btn-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.filtros.empresas = [];
      }
    }
  }, [_vm._v(" Limpar ")])])])], 1)], 1), _c('button', {
    staticClass: "btn btn-primary px-6",
    attrs: {
      "type": "submit",
      "disabled": _vm.carregando || _vm.filtros.empresas.length === 0,
      "data-testid": "atualizar-painel"
    }
  }, [_vm.carregando ? _c('span', {
    staticClass: "spinner spinner-sm spinner-light mr-2"
  }) : _vm._e(), _vm._v(" Atualizar ")])], 1)]), _c('small', {
    staticClass: "text-muted d-block mt-3"
  }, [_vm._v(" Vendas e financeiro respeitam o período. A aba Bancos apresenta o saldo atual das contas selecionadas. ")])], 1), _vm.carregando ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('span', {
    staticClass: "spinner spinner-primary"
  })]) : _vm.dashboard ? [_c('div', {
    staticClass: "row"
  }, _vm._l(_vm.cards, function (card) {
    return _c('div', {
      key: card.key,
      staticClass: "col-sm-6 col-xl-3 mb-5"
    }, [_c('div', {
      staticClass: "card card-custom h-100 painel-kpi"
    }, [_c('div', {
      staticClass: "card-body p-5"
    }, [_c('span', {
      staticClass: "text-muted font-weight-bold d-block mb-2"
    }, [_vm._v(" " + _vm._s(card.label) + " ")]), _c('strong', {
      staticClass: "font-size-h3",
      class: card.className || 'text-dark'
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(card.valor)) + " ")]), card.detalhe ? _c('small', {
      staticClass: "d-block text-muted mt-2"
    }, [_vm._v(" " + _vm._s(card.detalhe) + " ")]) : _vm._e()])])]);
  }), 0), _c('div', {
    staticClass: "card card-custom border mt-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('b-tabs', {
    attrs: {
      "content-class": "pt-5"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Vendas",
      "active": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-end mb-4"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-light-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportarVendas
    }
  }, [_c('i', {
    staticClass: "fas fa-file-csv mr-1"
  }), _vm._v(" Exportar vendas CSV ")])]), _c('div', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-xl-8 mb-5 mb-xl-0"
  }, [_c('div', {
    staticClass: "border rounded p-4 h-100"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Faturamento por empresa")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Comparação do valor fiscal no período. ")]), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "360",
      "options": _vm.graficoVendasOptions,
      "series": _vm.graficoVendasSeries
    }
  })], 1)]), _c('div', {
    staticClass: "col-xl-4"
  }, [_c('div', {
    staticClass: "border rounded p-4 h-100"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Participação no faturamento")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Distribuição do total entre as empresas. ")]), _vm.temFaturamento ? _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "360",
      "options": _vm.graficoParticipacaoOptions,
      "series": _vm.graficoParticipacaoSeries
    }
  }) : _c('div', {
    staticClass: "text-center text-muted py-15"
  }, [_vm._v(" Sem faturamento no período selecionado. ")])], 1)])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Empresa")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Vendas")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Faturamento")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ticket médio")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Participação")])])]), _c('tbody', _vm._l(_vm.relatorioVendas, function (empresa) {
    return _c('tr', {
      key: empresa.id_empresa
    }, [_c('td', [_c('strong', {
      staticClass: "d-block"
    }, [_vm._v(" " + _vm._s(empresa.nome) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(empresa.tipo) + " ")])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(empresa.quantidade_vendas) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(empresa.faturamento)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(empresa.ticket_medio)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarPercentual(empresa.participacao)) + " ")])]);
  }), 0)])])]), _c('b-tab', {
    attrs: {
      "title": "Financeiro"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-end mb-4"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-light-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportarFinanceiro
    }
  }, [_c('i', {
    staticClass: "fas fa-file-csv mr-1"
  }), _vm._v(" Exportar financeiro CSV ")])]), _c('div', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-xl-6 mb-5 mb-xl-0"
  }, [_c('div', {
    staticClass: "border rounded p-4 h-100"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Movimentação do período")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Recebimentos, pagamentos e resultado por empresa. ")]), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "360",
      "options": _vm.graficoFinanceiroOptions,
      "series": _vm.graficoFinanceiroSeries
    }
  })], 1)]), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('div', {
    staticClass: "border rounded p-4 h-100"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Contas em aberto")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Valores a receber, a pagar e respectivos vencidos. ")]), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "360",
      "options": _vm.graficoContasOptions,
      "series": _vm.graficoContasSeries
    }
  })], 1)])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Empresa")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Recebido")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Pago")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Resultado")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("A receber")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Receber vencido")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("A pagar")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Pagar vencido")])])]), _c('tbody', _vm._l(_vm.relatorioFinanceiro, function (empresa) {
    return _c('tr', {
      key: empresa.id_empresa
    }, [_c('td', [_c('strong', {
      staticClass: "d-block"
    }, [_vm._v(" " + _vm._s(empresa.nome) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(empresa.tipo) + " ")])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(empresa.receitas_recebidas)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(empresa.despesas_pagas)) + " ")]), _c('td', {
      staticClass: "text-right font-weight-bold",
      class: _vm.classeResultado(empresa.resultado_periodo)
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(empresa.resultado_periodo)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(empresa.contas_receber)) + " ")]), _c('td', {
      staticClass: "text-right text-danger"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(empresa.contas_receber_vencidas)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(empresa.contas_pagar)) + " ")]), _c('td', {
      staticClass: "text-right text-danger"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(empresa.contas_pagar_vencidas)) + " ")])]);
  }), 0)])])]), _c('b-tab', {
    attrs: {
      "title": "Bancos"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-items-center justify-content-between mb-4"
  }, [_c('div', [_c('strong', {
    staticClass: "d-block"
  }, [_vm._v("Saldos atuais")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Posição atual das contas bancárias, independente do período. ")])]), _c('button', {
    staticClass: "btn btn-sm btn-light-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportarBancos
    }
  }, [_c('i', {
    staticClass: "fas fa-file-csv mr-1"
  }), _vm._v(" Exportar bancos CSV ")])]), _c('div', {
    staticClass: "row mb-6"
  }, [_c('div', {
    staticClass: "col-xl-8 mb-5 mb-xl-0"
  }, [_c('div', {
    staticClass: "painel-grafico h-100"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Saldo bancário por empresa")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Soma das contas cadastradas em cada empresa. ")]), _vm.relatorioBancosPorEmpresa.length ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "360",
      "options": _vm.graficoBancosOptions,
      "series": _vm.graficoBancosSeries
    }
  }) : _c('div', {
    staticClass: "text-center text-muted py-15"
  }, [_vm._v(" Nenhuma conta bancária cadastrada. ")])], 1)]), _c('div', {
    staticClass: "col-xl-4"
  }, [_c('div', {
    staticClass: "resumo-bancos h-100"
  }, [_c('span', {
    staticClass: "text-muted font-weight-bold d-block mb-2"
  }, [_vm._v(" Saldo bancário consolidado ")]), _c('strong', {
    staticClass: "font-size-h1 d-block mb-6",
    class: _vm.classeResultado(_vm.saldoBancosTotal)
  }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(_vm.saldoBancosTotal)) + " ")]), _c('div', {
    staticClass: "d-flex justify-content-between border-top pt-4 mb-3"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Contas cadastradas")]), _c('strong', [_vm._v(_vm._s(_vm.relatorioBancos.length))])]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Contas com saldo negativo")]), _c('strong', {
    class: _vm.contasBancariasNegativas ? 'text-danger' : ''
  }, [_vm._v(" " + _vm._s(_vm.contasBancariasNegativas) + " ")])])])])]), _vm.relatorioBancos.length ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Empresa")]), _c('th', [_vm._v("Banco/conta")]), _c('th', [_vm._v("Agência")]), _c('th', [_vm._v("Conta")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Saldo atual")])])]), _c('tbody', _vm._l(_vm.relatorioBancos, function (banco) {
    return _c('tr', {
      key: banco.id_banco
    }, [_c('td', [_c('strong', {
      staticClass: "d-block"
    }, [_vm._v(" " + _vm._s(banco.empresa) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(banco.empresa_tipo) + " ")])]), _c('td', [_c('strong', [_vm._v(_vm._s(banco.nome))]), banco.codigo_banco ? _c('small', {
      staticClass: "text-muted ml-2"
    }, [_vm._v(" Cód. " + _vm._s(banco.codigo_banco) + " ")]) : _vm._e()]), _c('td', [_vm._v(_vm._s(banco.agencia || "—"))]), _c('td', [_vm._v(_vm._s(banco.conta || "—"))]), _c('td', {
      staticClass: "text-right font-weight-bold text-nowrap",
      class: _vm.classeResultado(banco.saldo)
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(banco.saldo)) + " ")])]);
  }), 0)])]) : _c('div', {
    staticClass: "alert alert-light-info mb-0"
  }, [_vm._v(" Nenhuma conta bancária encontrada nas empresas selecionadas. ")])])], 1)], 1)])] : _vm._e()] : _c('div', {
    staticClass: "alert alert-light-warning mb-0"
  }, [_vm._v(" Acesse a empresa matriz e configure um grupo empresarial antes de consultar o painel consolidado. ")])], 2)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('div', [_c('h3', {
    staticClass: "card-label mb-1"
  }, [_vm._v("Painel consolidado")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Visão somente leitura das empresas do grupo. ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', [_c('h4', {
    staticClass: "card-label mb-1"
  }, [_vm._v("Relatórios consolidados")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Comparativo por empresa no período selecionado. ")])])])]);
}];
export { render, staticRenderFns };